import { useState } from "react";
import ColorInput from "@shared/designSystem/ColorInput";
import { CardContainer, VerticalMainContainer, VerticalContainer } from "@shared/designSystem/Containers";
import { H1Title, H2Title } from "@shared/designSystem/Titles";
import { Text } from "@shared/designSystem/Texts";
import designSystemStyles from "@shared/styles/designSystemStyles";
import { TextInput } from "@shared/designSystem/TextInput";

const ColorInputShowcaseScreen = () => {
    const [selectedBrandColor, setSelectedBrandColor] = useState("#EC6C56");
    const [selectedTextColor, setSelectedTextColor] = useState("#FFFFFF");

    return (
        <VerticalMainContainer>
            <H1Title text="ColorInput Showcase" />
            <CardContainer>
                <VerticalContainer gap={designSystemStyles.gapLg} alignment="left" width="360px">
                    <H2Title text="Shared ColorInput" />
                    <ColorInput
                        label="Brand color"
                        value={selectedBrandColor}
                        onChange={setSelectedBrandColor}
                        placeholder="#EC6C56"
                        fallbackValue="#EC6C56"
                    />
                    <ColorInput
                        label="Text color"
                        value={selectedTextColor}
                        onChange={setSelectedTextColor}
                        placeholder="#FFFFFF"
                        fallbackValue="#FFFFFF"
                    />
                    <Text text={`Brand: ${selectedBrandColor || "none"}`} />
                    <Text text={`Text: ${selectedTextColor || "none"}`} />
                    <TextInput label={"Test"} value={""} onChange={function (value: string): void {
                        throw new Error("Function not implemented.");
                    } }></TextInput>
                </VerticalContainer>
            </CardContainer>
        </VerticalMainContainer>
    );
};

export default ColorInputShowcaseScreen;
